import { faRotateLeft } from '@fortawesome/pro-light-svg-icons'
import { LangModelType } from '@teinor/erp/types/company/config/lang'
import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderBoolean, CustomRenderLanguageName, DeleteRow } from '../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import ModalCreateLang from './ModalCreateLang'
import ModalDeleteLang from './ModalDeleteLang'

interface ConfigLangsProps extends ComponentWithPermissions {}

const ConfigLangs: React.FC<ConfigLangsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('langs', 'Idiomas'),
        newText: t('newLanguage', 'Nuevo idioma'),
    }

    return (
        <BaseScreenTable TableComponent={TableLangs} CreateModalComponent={ModalCreateLang} DeleteModalComponent={ModalDeleteLang} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableLangsProps extends TableComponentProps {}

const TableLangs: React.FC<TableLangsProps> = ({ setTableInstance, userPermissions, setOpened }) => {
    const { t } = useTwinTranslation()
   
    const columns: ColumnTableSchema<LangModelType> = [
        {
            id: 'iso',
            dataKey: 'id',
            width: 200,
            label: t('isoCode', 'Código ISO'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('isoCode', 'Código ISO') }
            }
        },
        {
            id: 'lang',
            dataKey: 'id',
            label: t('language', 'Idioma'),
            customRender: (parameterValue) => <CustomRenderLanguageName languageId={parameterValue} />,
            generalSearchable: false
        },
        {
            id: 'active',
            dataKey: 'active',
            label: t('active', 'Activo'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={45} />,
            generalSearchable: false
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => {
                const icon = !allRowData?.active ? faRotateLeft : undefined
                return <DeleteRow key={'delete' + parameterValue} {...{ icon, parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />
            },
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable  name='langs' columns={columns} getDataFrom='/api/app/config/lang/getAllLangs'  setTableInstance={setTableInstance}/>
    )
}

export default ConfigLangs